module.exports = __webpack_public_path__ + "assets/Marine.be11d392.svg";